module.exports = __webpack_public_path__ + "static/media/14_Payless.b5f6881b.png";